const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

function normalizeSystemName(reference = '') {
  return String(reference).trim().replace(/^@/, '').toUpperCase();
}

export function getSstSystemValue(reference, now = new Date()) {
  const name = normalizeSystemName(reference);
  if (/^(?:YES|NO|OK|EXIT|CANCEL|BTN(?!_?PRSD$)[A-Z0-9_]+)$/i.test(name)) {
    return name;
  }
  if (name === 'DATE') {
    const day = String(now.getDate()).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2);
    return `${day}${MONTHS[now.getMonth()]}${year}`;
  }
  if (name === 'TIME') {
    return `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
  }
  return undefined;
}


